// extracted by mini-css-extract-plugin
export default {"UserPic":"profile_UserPic__qHK8D"};